import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@salesforce/design-system-react';
const ConfirmActionModal = (props) => {
  return (
    <Modal
      footer={[
        <Button
          key="cancelBtn"
          variant="neutral"
          label="Cancel"
          onClick={props.toggleOpen}
        />,
        <Button
          key="promptBtn"
          variant="brand"
          label="Submit"
          onClick={() => props.onSubmit()}
        />,
      ]}
      directional
      isOpen={props.isOpen}
      onRequestClose={props.toggleOpen}
      heading={props.heading}
    >
      <div className="slds-m-around_medium">{props.children}</div>
    </Modal>
  );
};

ConfirmActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
};

export default ConfirmActionModal;
